var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmitBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 165,
    viewBox: "0 0 380 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6794 90.5307C115.001 51.2133 245.697 -12.7868 285.914 45.7515C336.184 118.924 229.82 181.047 220.828 126.719C211.835 72.3918 370.845 -55.3561 461.645 162.968",
    stroke: "#EF956F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M166.9 108.319L169.685 72.4751L203.65 66.1797L119.353 20.4396L6.00044 102.813L166.9 108.319Z",
    fill: "#FBBBA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.685 72.4751L166.9 108.319L6.00044 102.813M6.00044 102.813L203.65 66.1797L119.353 20.4396L6.00044 102.813Z",
    stroke: "#EF956F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.13 39.4414L7.39951 102.764",
    stroke: "#EF956F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.225 87.1154L168.243 73.8779L11.7696 102.389L167.225 87.1154Z",
    fill: "#EF956F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitBlog);
export default __webpack_public_path__ + "static/media/submit-blog.3a83a81e.svg";
export { ForwardRef as ReactComponent };